/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Roleserror3Inputs */

const en_coinvestments_draftemail_roleserror3 = /** @type {(inputs: Coinvestments_Draftemail_Roleserror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't load access roles, so access can't be set right now.`)
};

/**
* | output |
* | --- |
* | "We couldn't load access roles, so access can't be set right now." |
*
* @param {Coinvestments_Draftemail_Roleserror3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_roleserror3 = /** @type {((inputs?: Coinvestments_Draftemail_Roleserror3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Roleserror3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_roleserror3(inputs)
});
export { coinvestments_draftemail_roleserror3 as "coInvestments_draftEmail_rolesError" }